/** Translate an ApiError's server message_key (e.g. "errors.auth.email_taken")
 *  into a localized string. The first dotted segment is the i18n namespace. */
import { i18n } from '@/lib/i18n'
import { ApiError } from '@/lib/api'

export function apiErrorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    const dot = err.messageKey.indexOf('.')
    if (dot > 0) {
      return i18n.t(err.messageKey.slice(dot + 1), { ns: err.messageKey.slice(0, dot) })
    }
    return i18n.t(err.messageKey, { ns: 'errors' })
  }
  return i18n.t('generic', { ns: 'errors' })
}
